import React from "react";
import { useParams, Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const Img = ({src, alt}) => (
  <img src={src} alt={alt} className="w-full rounded-xl mb-4 object-cover" />
);

const content = {
  app: {
    title: "DigiFit™ App",
    img: "/assets/smartphone.jpg",
    paragraphs: [
      "The Companion Mobile App",
      "This is the user's personal wardrobe and style hub. Here, they can browse clothing from participating retailers, manage their virtual closet, and interact with their AI stylist.",
    ],
  },
  website: {
    title: "Website",
    img: "/assets/website.jpg",
    paragraphs: [
      "DigiFit™ is a next-generation virtual dressing room that merges the physical and digital worlds to solve the single biggest problem in fashion retail: returns. Our ecosystem is centered around the DigiFit Mirror™, a proprietary smart mirror that uses advanced laser 3D scanning and AI to create a micrometer-accurate digital avatar of the user.",
      "This technology allows consumers to virtually try on clothing from our network of retail partners in real-time, from the comfort of their homes, with absolute confidence in the fit. For retailers, DigiFit™ drastically reduces the costly and environmentally damaging cycle of returns. For consumers, it eliminates the guesswork and frustration of online shopping.",
      "DigiFit™ is not just a product; it is the essential infrastructure for the future of personalized, sustainable, and profitable fashion. We are bridging the gap between online convenience and in-store confidence.",
    ],
  },
  mirror: {
    title: "DigiFit Mirror™",
    img: "/assets/mirror.jpg",
    paragraphs: [
      "The DigiFit Mirror™",
      "A sleek, 30\" x 72\" smart mirror that is a technological powerhouse. Its embedded laser array and sensors perform a full-body scan in seconds, creating a precise 3D model of the user. The transparent OLED screen then overlays digital garments onto the user's real-time reflection with unparalleled realism.",
    ],
  },
  ai: {
    title: "AI DigiFit Style Consultant™",
    img: "/assets/consultant.jpg",
    paragraphs: [
      "The AI DigiFit Style Consultant™",
      "A proprietary AI trained on biometric fit data and individual user preferences. It provides personalized recommendations, suggests outfits, and helps users discover new styles that are guaranteed to fit them perfectly.",
    ],
  },
  retailer: {
    title: "DigiFit™ Retailer Network",
    img: "/assets/retail.jpg",
    paragraphs: [
      "The DigiFit™ Retailer Network",
      "Brands and retailers subscribe to our platform, digitize their collections, and integrate them into the DigiFit™ ecosystem. This allows them to offer virtual try-on experiences to a global audience, reducing inventory needs and eliminating returns.",
    ],
  },
  invest: {
    title: "Why You Should Invest",
    img: "/assets/invest.jpg",
    paragraphs: [
      "A Category-Defining Opportunity",
      "An investment in DigiFit™ is an opportunity to acquire a foundational stake in a company set to redefine an entire industry.",
      "Strong, Defensible IP",
      "We have a robust intellectual property strategy, with utility and design patents filed for our core mirror technology, simulation algorithms, and user interface.",
      "Hybrid Revenue Model",
      "Our business model is built for rapid and sustained growth, combining one-time hardware sales/leases to consumers with recurring B2B SaaS revenue from our retail partners.",
      "Proven Demand and a Clear Go-to-Market Strategy",
      "The demand for a solution to the returns problem is universal. Our phased rollout plan is designed for strategic market penetration and scaling.",
      "Significant Social and Environmental Impact",
      "DigiFit™ is a commercially powerful venture with a conscience, offering a tangible solution to reduce waste and promote more sustainable consumption.",
      "Clear Funding Ask",
      "We are seeking $6.75 million to finalize hardware manufacturing, build out our AI platform, onboard our initial retail partners, and launch our marketing initiatives.",
      "DigiFit™ is where precision technology meets personal style. We invite you to join us in building the new architecture of fashion.",
    ],
    emphasize: [0,2,4,6,8,10,12]
  },
};

export default function DetailPage() {
  const { slug } = useParams();
  const data = content[slug] || { title: "Details", paragraphs: [] };
  const isInvest = slug === 'invest';
  return (
    <div className="min-h-screen relative" style={{animation:'ani_gradient 21s ease infinite', background:'linear-gradient(-60deg, #F505D5 15%, #F507F5 19%, #2525FA 54%, #42F2FF 85%)', backgroundSize:'200% 200%'}}>
      <style>{`@keyframes ani_gradient{0%{background-position:0% 0%}50%{background-position:100% 100%}100%{background-position:0% 0%}}`}</style>
      <img src="/assets/digifit_logo.png" alt="logo" className="absolute right-6 top-6 w-12 h-12" />
      <div className="max-w-5xl mx-auto px-4 py-10 space-y-6">
        <Link to="/app" className="text-white/80 underline" data-testid="back-to-app">← Back</Link>
        <Card className="bg-black/60 backdrop-blur-xl border-white/10" data-testid="detail-card">
          <CardHeader>
            <CardTitle className="text-white text-3xl">{data.title}</CardTitle>
          </CardHeader>
          <CardContent className="text-white/85 space-y-4 leading-relaxed">
            {data.img ? <Img src={data.img} alt={data.title} /> : null}
            {data.paragraphs.map((p, i) => {
              const emph = (content.invest?.emphasize || []).includes(i);
              return <p key={i} className={isInvest && emph ? "text-white font-semibold text-base sm:text-lg" : "text-white/90 text-sm"}>{p}</p>
            })}
          </CardContent>
        </Card>
      </div>
      <footer className="w-full text-center text-xs text-white/80 py-8" data-testid="global-footer">© 2025 All Rights Reserved | 713 Consulting & Development | Keith Bolden</footer>
    </div>
  );
}
